// @ts-nocheck
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { BlockBorderProps, BlockParsedBaseProps } from "@store/Library/Components/Toolkit/Block/Block";
import { defaultBorderProps } from "@store/Library/Components/Toolkit/Block/defaultProps";
import { BlockVariantBaseProps, BlockVariantTypeProps } from "@store/Library/Components/Toolkit/Block/variant/base";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { css } from "styled-components";

export interface BlockVariantSeparatedBaseProps {
    border: BlockBorderProps;
    adaptToContext?: boolean;
}
export interface BlockVariantSeparatedProps extends BlockVariantBaseProps, BlockVariantSeparatedBaseProps {}

const typeProps: BlockVariantTypeProps<BlockVariantSeparatedProps> = {
    defaultProps: {
        border: defaultBorderProps,
    },
    staticProps: {
        containerCss: css<BlockParsedBaseProps>`
            ${({ variantProps }) => {
                if (variantProps?.separated?.adaptToContext) {
                    return css`
                        &:first-child [class^="BlockWrapper-"] {
                            padding-top: 0;
                            border-top: 0;
                        }

                        &:last-child [class^="BlockWrapper-"] {
                            padding-bottom: 0;
                            border-bottom: 0;
                        }
                    `;
                }
            }}
        `,
        wrapperCss: css<BlockParsedBaseProps>`
            ${({ theme, variantProps, variantSide, margin }) => {
                const { width, type, color } = variantProps.separated.border;
                const _topStyles = `border-top: ${width} ${type} ${resolveColor(color, theme)};`;
                const _bottomStyles = `border-bottom: ${width} ${type} ${resolveColor(color, theme)};`;

                switch (variantSide) {
                    case "top":
                        return css`
                            ${_topStyles}
                            ${breakpointValues(margin, "padding-top")}
                        `;
                    case "bottom":
                        return css`
                            ${_bottomStyles}
                            ${breakpointValues(margin, "padding-bottom")}
                        `;
                    default:
                        return css`
                            ${_topStyles}
                            ${_bottomStyles}
                        ${breakpointValues(margin, ["padding-top", "padding-bottom"])}
                        `;
                }
            }}
        `,
    },
};

export default typeProps;
